import type { FC } from "react";

import type { FindingCode } from "../model/Finding";
import { CoreItemMissing } from "./CoreItemMissing";
import { CoreItemsOnTime } from "./CoreItemsOnTime";
import { CostlyDeath } from "./CostlyDeath";
import { DefenseMismatch } from "./DefenseMismatch";
import { DiedAlone } from "./DiedAlone";
import { DiedOutnumbered } from "./DiedOutnumbered";
import { EnemyEscaped } from "./EnemyEscaped";
import type { FindingProps } from "./FindingProps";
import { ItemBoughtLate } from "./ItemBoughtLate";
import { ItemSoldSoon } from "./ItemSoldSoon";
import { KilledByHero } from "./KilledByHero";
import { KilledByObjective } from "./KilledByObjective";
import { LaneGanked } from "./LaneGanked";
import { LaneResult } from "./LaneResult";
import { LowHpSurvival } from "./LowHpSurvival";
import { MetricRated } from "./MetricRated";
import { MissedTeamfight } from "./MissedTeamfight";
import { MultiKill } from "./MultiKill";
import { NoAntiHeal } from "./NoAntiHeal";
import { OffBuildEarly } from "./OffBuildEarly";

// Код находки → компонент. Тип — по union `Finding` из контракта: добавили код на бэкенде —
// `pnpm typecheck` упадёт, пока здесь нет компонента для него.
export type FindingRenderers = { [C in FindingCode]: FC<FindingProps<C>> };

export const findingRenderers: FindingRenderers = {
  item_bought_late: ItemBoughtLate,
  core_item_missing: CoreItemMissing,
  off_build_early: OffBuildEarly,
  item_sold_soon: ItemSoldSoon,
  no_anti_heal: NoAntiHeal,
  defense_mismatch: DefenseMismatch,
  core_items_on_time: CoreItemsOnTime,
  lane_result: LaneResult,
  killed_by_hero: KilledByHero,
  died_outnumbered: DiedOutnumbered,
  died_alone: DiedAlone,
  lane_ganked: LaneGanked,
  costly_death: CostlyDeath,
  killed_by_objective: KilledByObjective,
  low_hp_survival: LowHpSurvival,
  enemy_escaped: EnemyEscaped,
  missed_teamfight: MissedTeamfight,
  multi_kill: MultiKill,
  metric: MetricRated,
};
